import LinkButton from '@standardsdigital/ui-components/LinkButton';
import { FileXIcon, FrownIcon, LinkIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { localizePathname } from 'util/util';
import { routes } from 'util/routes';
import styles from './NotFoundPage.module.css';

function DashlineSvg() {
  return (
    <svg
      className={styles.dashline}
      width="2.25rem"
      height="0.5rem"
      stroke="currentColor"
      viewBox="0 0 36 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M4 4H32"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeDasharray="0.1 8"
      />
    </svg>
  );
}

function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <section className={styles.notFoundPage}>
      <div className={styles.visual} aria-hidden>
        <LinkIcon className={styles.icon} size="3em" />
        <DashlineSvg />
        <FileXIcon className={styles.iconShake} size="5em" />
        <DashlineSvg />
        <FrownIcon className={styles.icon} size="3em" />
      </div>
      <h1 className={`sd-heading-xl ${styles.title}`}>{t('notFound.title')}</h1>
      <p className={`sd-body-xl ${styles.text}`}>{t('notFound.text')}</p>
      <LinkButton
        variant="primary"
        component={Link}
        to={localizePathname(routes.home.to())}
      >
        {t('notFound.action')}
      </LinkButton>
    </section>
  );
}

export default NotFoundPage;
